const TinodeLoadingScreen = ({
  message = "Menghubungkan ke server chat...",
  subMessage = null,
  showRetryHint = false,
  onRetry = null,
  error = null,
}) => {
  if (error) {
    return (
      <div className="flex items-center justify-center h-screen bg-gray-50">
        <div className="text-center bg-white p-8 rounded-xl shadow-sm max-w-md w-full mx-4">
          <div className="text-5xl mb-4">⚠️</div>
          <h2 className="text-lg font-semibold text-gray-800 mb-2">
            Gagal Terhubung
          </h2>
          <p className="text-gray-500 text-sm mb-6">{error}</p>
          {onRetry && (
            <button
              onClick={onRetry}
              className="px-6 py-2.5 bg-blue-500 text-white rounded-lg hover:bg-blue-600 transition-colors text-sm font-medium"
            >
              Coba Lagi
            </button>
          )}
        </div>
      </div>
    );
  }

  return (
    <div className="flex items-center justify-center h-screen bg-gray-50">
      <div className="text-center">
        <div className="relative w-16 h-16 mx-auto mb-6">
          <div className="absolute inset-0 rounded-full border-4 border-blue-100"></div>
          <div className="absolute inset-0 rounded-full border-4 border-blue-500 border-t-transparent animate-spin"></div>
        </div>

        <p className="text-gray-700 font-medium text-base mb-1">{message}</p>

        {subMessage && (
          <p className="text-gray-400 text-sm mt-1">{subMessage}</p>
        )}

        {showRetryHint && (
          <p className="text-gray-400 text-xs mt-4">
            Mencoba menghubungkan kembali...
          </p>
        )}
      </div>
    </div>
  );
};

export default TinodeLoadingScreen;
